// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"86842e61","858":"e7c9fb2a"}[chunkId] + ".chunk.js";
};